window.addEventListener('load', () => {
    $("#checkoutForm").on('submit', function (e) {
        let $form = $(this);
        e.preventDefault();

        let $data= {
            endpoint: $form.find('input[name="endpoint"]').val(),
            merchantPublicKey : $form.find('input[name="merchantPublicKey"]').val(),
            type: $form.find('input[name="type"]').val(),
            typeId: $form.find('input[name="type_id"]').val(),
            cardNumber : $form.find('input[name="card_number"]').val(),
            expirationMonth : $form.find('select[name="expiration_month"]').val(),
            expirationYear: $form.find('select[name="expiration_year"]').val(),
            cvc: $form.find('input[name="security_code"]').val(),
            firstName: $form.find('input[name="first_name"]').val(),
            lastName: $form.find('input[name="last_name"]').val(),
            email: $form.find('input[name="email"]').val(),
        };

        let _uri = 'card[number]='+ $data.cardNumber;
        _uri += '&card[expirationMonth]='+ $data.expirationMonth;
        _uri += '&card[expirationYear]='+ $data.expirationYear;
        _uri += '&card[cvc]='+ $data.cvc;
        _uri += '&card[holderName]='+ $data.firstName+' '+$data.lastName;
        _uri += '&card[holderEmail]='+ $data.email;

        _uri += '&merchantPublicKey='+$data.merchantPublicKey;
        let post = encodeURI(_uri);

        let xhr = new XMLHttpRequest();
        xhr.open('POST', $data.endpoint+'/cardToken');
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.onreadystatechange = (res) => {
            console.log(res);
            if (xhr.readyState === 4) {
                response = JSON.parse(xhr.response);

                let checkoutData = {
                    cardTokenId: response.cardTokenId,
                    type: $data.type,
                    type_id: $data.typeId,
                    first_name: $data.firstName,
                    last_name: $data.lastName,
                };

                let htmlForm = '<input type="hidden" name="cardTokenId" value="'+checkoutData.cardTokenId+'"/>'+
                    '<input type="hidden" name="type" value="'+checkoutData.type+'"/>'+
                    '<input type="hidden" name="type_id" value="'+checkoutData.type_id+'"/>'+
                    '<input type="hidden" name="first_name" value="'+checkoutData.first_name+'"/>'+
                    '<input type="hidden" name="last_name" value="'+checkoutData.last_name+'"/>';


                let _form = $('<form action="/payments/checkout" method="POST"></form>').appendTo('body');
                _form.html(htmlForm);
                _form.submit();
            }
        };
        xhr.send(post);

        $(this).find('.fa-spin').toggleClass('d-none');
        $(this).find('button[type=submit]').attr('disabled', true);
    });
});
